<template lang="pug">
transition-group(
    tag="div"
    class="fixed inset-0 flex flex-col justify-end items-center px-3 py-3 pointer-events-none z-third-party md:p-6 md:justify-start md:items-end"
    enter-active-class="transition-opacity ease-out duration-200"
    enter-class="opacity-0"
    leave-active-class="transition-opacity ease-in duration-300"
    leave-to-class="opacity-0"
)
    template(v-for="(notification, index) in notifications")
        SimpleNotification(
            class="mb-1"
            :key="notification.id"
            :notification="notification"
            :type="notification.type"
            @close="closeNotification(index)"
        )

</template>

<script>
import SimpleNotification from './_components/simple'

export default {
    name: 'Notifications',
    components: {
        SimpleNotification,
    },
    computed: {
        notifications() {
            return this.$notifications.notifications
        },
    },
    methods: {
        closeNotification(index) {
            this.$notifications.remove(index)
        },
    },
}
</script>
